/** The Amazon affiliate tag of this build (none if unset). Kept apart from HomeBits so the buy button and the events bridge do not load it. */
export const TAG = (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_AMAZON_TAG || undefined;
